/* eslint-disable react-refresh/only-export-components */

import {
  useMemo,
  useContext,
  createContext,
  useState,
  FC,
  PropsWithChildren,
} from 'react';

export const SubscriptionContext = createContext({
  state: { isSubscribe: false },
});
export const useSubscriptionContext = () =>
  useContext<{
    state: {
      isSubscribe: boolean;
    };
    dispatch?: React.Dispatch<React.SetStateAction<object>>;
  }>(SubscriptionContext);

const Subscription: FC<PropsWithChildren> = ({ children }) => {
  const [state, dispatch] = useState({ isSubscribe: false });

  const value = useMemo(() => ({ state, dispatch }), [state, dispatch]);

  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  );
};

export default Subscription;
